import {DependencyInjectId} from '@@/package/const/DependencyInjectId';
import {type ApplicationContextInterface} from "@@/package/application/applicationContext";
import ContestApi from "~~/package/apis/contest/ContestApi";
import {ContestListModel} from "~~/package/mapper/contest/model/ContestListModel";
import {ContestLeaderBoardModel} from "~~/package/mapper/contest/model/ContestLeaderBoardModel";
// @ts-ignore
import type ContestResponse from "~~/package/apis/contest/response/ContestResponse";
import {PageModel} from "~~/package/mapper/common/model/PageModel";
import {ContestLeaderBoardExistsModel} from "~~/package/mapper/contest/model/ContestLeaderBoardExistsModel";
// @ts-ignore
import type ContestRequest from "~~/package/apis/contest/response/ContestRequest";
import {ContestHelper} from "~~/package/mapper/contest/ContestHelper";
import {CautionType} from "~~/package/types/CautionType";
import type CustomResponse from "~~/package/types/ResponseType";
import type {LearningTokenData} from "~~/package/mapper/learning/model/LearningTokenData";

export default class ContestMapper {
    protected contestApi : ContestApi;

    constructor(context: ApplicationContextInterface) {
        this.contestApi =  context.getService<ContestApi>(DependencyInjectId.ContestApi)
    }

    public async getContestList(Lang: string): Promise<ContestListModel[]> {
        const contestResponse: CustomResponse<ContestListModel[]> = (await this.contestApi.getContestList(Lang)).data;
        return contestResponse.data.map((contest: ContestListModel) => ContestListModel.create(contest));
    }

    public async getContestDetail(id: number, Lang: string): Promise<ContestListModel> {
        const contestResponse: CustomResponse<ContestListModel> = (await this.contestApi.getContestDetail(id, Lang)).data;
        return ContestListModel.create(contestResponse.data);
    }

    public async getContestLeaderBoardList(id:number, page:number, itemSize: number): Promise<PageModel<ContestLeaderBoardModel>> {
        const contestResponse: CustomResponse<PageModel<ContestLeaderBoardModel>> = (await this.contestApi.getContestLeaderBoard(id, page, itemSize)).data;
        return PageModel.create(contestResponse.data);
    }

    public async getContestMyLeaderBoard(id:number): Promise<ContestLeaderBoardModel> {
        const contestResponse: CustomResponse<ContestLeaderBoardModel> = (await this.contestApi.getContestMyLeaderBoard(id)).data;
        return ContestLeaderBoardModel.create(contestResponse.data);
    }

    public async getContestAdminGrading(id:number): Promise<ContestLeaderBoardExistsModel> {
        const contestResponse: CustomResponse<ContestLeaderBoardExistsModel> = (await this.contestApi.getContestAdminGrading(id)).data;
        return contestResponse.data;
    }

    public async getContestAuthentication(id:number, code: string): Promise<boolean> {
        const contestResponse: CustomResponse<boolean> = (await this.contestApi.getContestAuthentication(id, code)).data;
        return contestResponse.data;
    }

    public async getContestReceive(contestId: number, termsId: number): Promise<boolean> {
        const contestResponse: CustomResponse<boolean> = (await this.contestApi.getContestReceive(contestId, termsId)).data;
        return contestResponse.data;
    }

    public async getContestData(contestId: number, lang?: string): Promise<ContestResponse> {
        const contestResponse: CustomResponse<ContestResponse> = (await this.contestApi.getContestData(contestId, lang)).data;
        contestResponse.data.contestTaskList = ContestHelper.mappingContestTask(contestResponse.data.contestTaskList);
        return contestResponse.data;
    }

    public async submitAnswer(contestRequest: ContestRequest, tokenData: LearningTokenData): Promise<boolean> {
        return (await this.contestApi.submitAnswer(contestRequest, tokenData)).data.data;
    }

    public async setCurrentContestTask(id: number, taskId: number): Promise<boolean> {
        return (await this.contestApi.setCurrentContestTask(id, taskId)).data.data;
    }

    public async setContestUserAction(contestId: number, suspiciousAction: CautionType, actionContent?: string): Promise<number> {
        return (await this.contestApi.setContestUserAction(contestId, suspiciousAction, actionContent)).data.data;
    }
}
